export enum OrionModule {
  ACCOUNT = 'ACC',
  PARTNER = 'PRT',
  ALTIO = 'OCA',
}

export const OrionSubmodule = {
  ACCOUNT: {
    COMPANY: 'CMP',
    CONTACT: 'CON',
    SUBSCRIPTION: 'SUB',
    ORDER: 'ORD',
    BILLING_ORDER: 'BOR',
    REQUEST: 'REQ',
    OPPORTUNITY: 'OPP',
  },
  PARTNER: {
    PARTNER: 'PRT',
    PRODUCT: 'PRD',
    SKU: 'SKU',
    PLAN: 'PLN',
    PRICEBOOK: 'PRB',
  },
  ALTIO: {
    CLOUD_SUMMARY: 'CACS',
    ACCOUNTS: 'CAA',
    REPORTS: 'CAR',
    RESOURCES: 'CARE',
    REPORT_APPROVAL: 'CARA',
  },
} as const;

type AccountValues = (typeof OrionSubmodule.ACCOUNT)[keyof typeof OrionSubmodule.ACCOUNT];
type PartnerValues = (typeof OrionSubmodule.PARTNER)[keyof typeof OrionSubmodule.PARTNER];
type AltioValues = (typeof OrionSubmodule.ALTIO)[keyof typeof OrionSubmodule.ALTIO];

export type OrionSubmoduleOptions = AccountValues | PartnerValues | AltioValues;

export enum OrionAccess {
  CREATE = 'create',
  EDIT = 'edit',
  UPDATE = 'update',
  VIEW = 'view',
  DELETE = 'delete',
}
